services.service('ClosedTradeService', [
    '$q', 'moment',
    'API', 'constants', 'ClosedTradeCollection', 'ClosedTradeModel', 'ServerTimeService','UserService',
    function ($q, moment, API, Const, ClosedTradeCollection, ClosedTradeModel, ServerTimeService, UserService) {
        var self = this;
        self.collection = null;


        function getDateRange(range) {

            function getStartTime(frame) {
                return moment.utc(ServerTimeService.time).startOf(frame);
            }

            function getRangeDay(days) {
                return getStartTime('day').subtract(days, 'day');
            }

            function getRangeWeek(weeks) {
                return getStartTime('week').subtract(weeks, 'week');
            }

            function getRangeMonth(months) {
                return getStartTime('month').subtract(months, 'month');
            }

            var rangeParsed = range.split(' '),
                returnDate;

            if (rangeParsed[1].toLowerCase().match('day')) {
                returnDate = getRangeDay(parseInt(rangeParsed[0], 10));
            }
            if (rangeParsed[1].toLowerCase().match('week')) {
                returnDate = getRangeWeek(parseInt(rangeParsed[0], 10));
            }
            if (rangeParsed[1].toLowerCase().match('month')) {
                returnDate = getRangeMonth(parseInt(rangeParsed[0], 10));
            }

            return returnDate.unix();
        }

        this.init = function () {

            self.collection = new ClosedTradeCollection();

            var user = UserService.get();
            if (!user.isLoggedInMT4) {
                log('not starting closedtrades service');
                return;
            }
        };

        this.getHistory = function (range) {
            return getClosedTrades(range)
                .then(checkResponse)
                .then(initTrades)
                .catch(function (err) {
                    log('no closed trades', err);
                });
        };
        function checkResponse(data) {
            if (data.status !== 1 || !data.Trades) {
                return $q.reject(data.code);
            }
            return data;
        }

        function initTrades(data) {
            data.Trades.forEach(function (trade) {
                self.collection.add(new ClosedTradeModel(trade));
            });
        }

        function setTimeRange(range){
            var startTime,
                endTime;

            switch (range) {
            case 'day':
                startTime = getDateRange('0 days');
                break;
            case 'threedays':
                startTime = getDateRange('2 days');
                break;
            case 'week':
                startTime = getDateRange('0 week');
                break;
            case'month':
                startTime = getDateRange('0 month');
                break;
            case 'threemonths':
                startTime = getDateRange('2 month');
                break;
            case 'all':
                startTime = 1;
                break;
            }

            endTime = parseInt(ServerTimeService.time / 1000, 10);

            return ({
                Start: startTime,
                End: endTime
            })
        }

        function getClosedTrades(range) {
            self.collection && self.collection.clear();
            return API.mt4GetClosedPositions(setTimeRange(range));
        }

        this.clear = function () {
            log('clear closedtrade service');
            self.collection && self.collection.clear();
            // self.collection = null;
        };

        return this;
    }]);
